<section class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
        <div class="d-flex justify-content-center py-4">
          <a href="index.html" class="logo d-flex align-items-center w-auto">
            <img src="https://patient-tracker.s3.us-east-1.amazonaws.com/image/logo.png" alt="" />
            <span class="d-none d-lg-block">Patient Tracker</span>
          </a>
        </div>
        <!-- End Logo -->

        <div class="card mb-3">
          <div class="card-body">
            <div class="pb-3">
              <h5 class="card-title mb-2 pb-0 fs-4">Login to Your Account</h5>
              <p class="small">Enter your Email & Password to login</p>
            </div>

            <form class="row g-3 needs-validation" (ngSubmit)="signin()" [formGroup]="SigninForm">
              <div class="col-12">
                <div class="form-group">
                  <label for="email">Email</label>
                  <div
                    class="input-group"
                    [ngClass]="{
                      'has-invalid': SigninForm.get('email')?.invalid && SigninForm.get('email')?.touched
                    }"
                  >
                    <input placeholder="email@example.com" type="text" class="form-control" formControlName="email" tabindex="1" id="email" />
                    <span class="error-message" *ngIf="(SigninForm.get('email')?.errors?.['required'] && SigninForm.get('email')?.touched)">Email is required!</span>
                    <span class="error-message" *ngIf="SigninForm.get('email')?.errors?.['email']">Enter valid Email !</span>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <div class="d-flex justify-content-between">
                    <label for="password">Password</label
                    ><button tabindex="0" class="btn btn-sm btn-link" type="button" (click)="ShowPassword = !ShowPassword">{{ ShowPassword ? 'Hide' : 'Show' }} Password</button>
                  </div>
                  <div
                    class="input-group"
                    [ngClass]="{
                      'has-invalid': SigninForm.get('password')?.invalid && SigninForm.get('password')?.touched
                    }"
                  >
                    <input placeholder="P@ssword1" [type]="ShowPassword ? 'text' : 'password'" class="form-control" tabindex="1" formControlName="password" id="password" />

                    <span class="error-message" *ngIf="(SigninForm.get('password')?.errors?.['required']) && SigninForm.get('password')?.touched">Please enter password!</span>
                  </div>
                </div>
              </div>

              <div class="col-12 text-end">
                <p class="small mb-0"><a routerLink="../forget-password">Forget Password ?</a></p>
              </div>

              <div class="col-12">
                <button class="btn btn-primary w-100" type="submit" tabindex="1" [disabled]="!SigninForm.valid || IsLoading"><loading /> Login</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
